import { Children, useEffect, useState } from "react"
import images from "../libs/images"
import Button from "./Button"
import { LangText } from "../zustand/dict";
/**
 * 
 * @param {{
 * type?:"child"|"info"|"custom"
 * children:any
 * title:string
 * message:string
 * open:boolean
 * setOpen:(open:boolean)=>void
 * confirm:string
 * onConfirm:()=>void
 * cancel:string
 * onCancel:()=>void
 * }} props 
 * @returns 
 */
export default function Modal(props) {
    const {
        type = "info",
        children,
        title = "",
        message = "",
        open = false,
        setOpen,
        confirm = <LangText id={"btn_confirm"} />,
        onConfirm,
        cancel = <LangText id={"btn_close"} />,
        onCancel,
        isBackClose = true
    } = props

    const [visible, setVisible] = useState(false)

    useEffect(() => {
        setVisible(open)

        if (open) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

    }, [open])

    return <div className={`modal-area ${visible ? "" : "hide"}`}>

        <div className="modal-bg" onClick={() => {
            if (isBackClose) {
                if (setOpen) setOpen(false);
            }
        }} />

        <div className={`modal-contents ${type ? type : "info"}`}>
            {type === "child" && <>
                <div className="header-logo al-center">lab.aiwith.art</div>
                <div className="title2 al-center mt-8">{title}</div>
                {children}
            </>}
            {type === "info" && <>
                {/* <images.AlertInfo style={{ width: 15, height: 15 }} /> */}
                <img style={{ width: 15, height: 15 }} src={images.icn_alert_info}></img>
                <div className="title2 al-center mt-8">{title}</div>
                <div className="body2 al-center mt-8">{message}</div>
            </>}
            {type === "custom" && <>
                {children}
            </>}
            {onConfirm && <Button
                style={{ marginTop: 24 }}
                title={confirm}
                type={1}
                onClick={() => {
                    if (onConfirm) onConfirm();
                }} />}
            {onCancel && <Button
                style={{ marginTop: 12 }}
                title={cancel}
                type={6}
                onClick={() => {
                    if (setOpen) setOpen(false);
                    if (onCancel) onCancel();
                }}
            />}
        </div>

    </div>
}